"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractStatus = void 0;
var ContractStatus;
(function (ContractStatus) {
    ContractStatus[ContractStatus["CREATED"] = 0] = "CREATED";
    ContractStatus[ContractStatus["SIGNED"] = 1] = "SIGNED";
    ContractStatus[ContractStatus["CANCELLED"] = 2] = "CANCELLED";
    ContractStatus[ContractStatus["REVISED"] = 3] = "REVISED";
    ContractStatus[ContractStatus["EXPIRED"] = 4] = "EXPIRED";
    ContractStatus[ContractStatus["PAUSED"] = 5] = "PAUSED";
})(ContractStatus = exports.ContractStatus || (exports.ContractStatus = {}));
//# sourceMappingURL=contract.js.map